import ProductTile from "../../ProductTile";
import CarouselProductHero from "../../CarouselProductHero";
import CategoryTile from "../CategoryTile";
import styles from "./CategoryPreviewCarousel.css";
import { CAROUSEL_CATEGORY_TILE_GRID_ITEM_COUNT } from "./constants";
import removeLabelsData from "../removeLabelsData";

const renderProducts = ({ products, ...rest }) => {
  const regularProductsCount =
    products.length - CAROUSEL_CATEGORY_TILE_GRID_ITEM_COUNT;
  const regularProducts = products.slice(0, regularProductsCount);
  const categoryTileProducts = products.slice(regularProductsCount);

  const productTiles = regularProducts
    .map(removeLabelsData)
    .map((product, index) => (
      <ProductTile
        {...product}
        key={product.id}
        index={index}
        ProductHeroComponent={CarouselProductHero}
        className={styles.productTile}
        {...rest}
      />
    ));

  const categoryTile = (
    <CategoryTile products={categoryTileProducts} {...rest} />
  );

  return [...productTiles, categoryTile];
};

export default renderProducts;
